import DefaultBannerBackgroundUrl from '@assets/images/certificates/banner.png';

export const DEFAULT_BANNER_BACKGROUND = DefaultBannerBackgroundUrl;

export const getBannerBackgroundSrc = (src: string | null | undefined): string =>
  src ?? DEFAULT_BANNER_BACKGROUND;
